import { useAuthContextSelector } from "../../../hooks/use-auth";
import useIsAuthenticated from "../../../hooks/use-is-authenticated";
import usePodActivationAuthorization from "./usePodActivationAuthorization";
import { usePodDetails } from "./usePodDetails";

export default function useUnlockAllowed(podKeyOrSerialNumber?: string) {
  // Load membership to see if user has an active memebership to unlock any pod
  const isAuthenticated = useIsAuthenticated();
  const isLoadingMembershipSubscription = useAuthContextSelector(
    c => c.isLoadingMembershipSubscription
  );
  const membershipSubscription = useAuthContextSelector(
    c => c.membershipSubscription
  );

  const [podDetails, isLoadingPodDetails] = usePodDetails(podKeyOrSerialNumber);

  // Load activation sequence to see if current user still has access without membership (Previously unlocked..)
  const {
    data: isPodActivationAllowed,
    isLoading: isLoadingActivationSequence
  } = usePodActivationAuthorization(
    isAuthenticated ? podDetails?.podSerialNumber : null
  );

  const isLoadingUnlockAllowed =
    isLoadingPodDetails ||
    isLoadingMembershipSubscription ||
    isLoadingActivationSequence;

  const isUnlockAllowed = !!membershipSubscription || isPodActivationAllowed;

  return { isUnlockAllowed, isLoadingUnlockAllowed };
}
